import * as R from "ramda";
import { getArtefactTypeFromListType } from "./getArtefactTypeFromList.mjs";
const parseArtefactRelatives = ({ sdmxJson, artefactId }) => R.pipe(
  R.propOr({}, "data"),
  R.mapObjIndexed((list, listType) => {
    const type = getArtefactTypeFromListType(listType);
    return R.reduce(
      (acc, artefact) => {
        const label = R.prop("name")(artefact);
        const version = artefact.version;
        const agencyId = artefact.agencyID;
        const code = artefact.id;
        const isFinal = artefact.isFinal;
        const sdmxId = `${agencyId}:${code}(${version})`;
        if (`${type}:${sdmxId}` === artefactId) {
          return acc;
        }
        const annotations = R.propOr([], "annotations", artefact);
        return R.append(
          {
            annotations,
            label,
            version,
            agencyId,
            code,
            isFinal,
            sdmxId,
            type
          },
          acc
        );
      },
      [],
      list
    );
  }),
  R.values,
  R.unnest
)(sdmxJson);
export {
  parseArtefactRelatives
};
